import { httpRequest } from "@services/http";

export class CommandaRequestChangePassword {
    async run(email: string) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/auth/password-reset/`;
        const response = await httpRequest(url, { method: "POST", body: { username: email } });
        return response;
    }
}